export const getAppKey = () => import.meta.env.VITE_APP_KEY;
